export class RandomUtils {

    public static getRandom(array: string[]) {
        return array[Math.floor(Math.random() * array.length)];
    }

    public static getSeededRandom(seed: number) {
        return new SeededRandom(seed).random();

    }
}

class SeededRandom {
    private seed: number;

    constructor(seed: number) {
        this.seed = seed;
    }

    // Generates a random number between 0 (inclusive) and 1 (exclusive)
    random(): number {
        // LCG (Linear Congruential Generator) algorithm parameters
        const a = 1664525;
        const c = 1013904223;
        const m = 2 ** 32;

        // Update the seed and return a normalized value
        this.seed = (a * this.seed + c) % m;
        return this.seed / m;
    }
}

